import React, { useState, useCallback } from "react"
import { Tabs, TabsItem } from "@eventbrite/marmalade"
import { renderEnhancedRichText } from "../../utils/contentful/enhanced-rich-text-renderer"
import { events } from "../../utils/heap/tracking_events"
import * as styles from "./NumberedList.module.scss"

interface NumberedListVariation {
  __typename: string
  contentful_id: string
  numberedListVariationTitle: string[]
  numberedListVariationSteps: {
    raw: string
  }
}

interface NumberedListData {
  __typename: string
  contentful_id: string
  numberedListInternalTitle: string
  numberedListVariations: NumberedListVariation[]
}

interface NumberedListProps {
  data: NumberedListData
  articleId?: number
}

export const NumberedList: React.FC<NumberedListProps> = ({
  data,
  articleId
}) => {
  const [activeTab, setActiveTab] = useState<string>("0")

  const handleTabChange = useCallback(
    (value: string) => {
      setActiveTab(value)
      const index = parseInt(value, 10)
      const variation = data?.numberedListVariations?.[index]
      if (variation) {
        const variationTitle =
          variation.numberedListVariationTitle?.[0] || `Option ${index + 1}`
        events?.numberedListTabChange(
          data?.numberedListInternalTitle ?? "",
          variationTitle,
          variation.contentful_id,
          "NumberedList",
          articleId
        )
      }
    },
    [data?.numberedListVariations, data?.numberedListInternalTitle, articleId]
  )

  if (!data?.numberedListVariations?.length) {
    return null
  }

  return (
    <div>  
      <div className={styles.tabsWrapper}>
        <Tabs
          aria-label={data.numberedListInternalTitle || "Numbered list options"}
          defaultValue={activeTab}
          onValueChange={handleTabChange}
        >
          {data.numberedListVariations.map((variation, index) => (
            <TabsItem key={variation.contentful_id} value={index.toString()}>
              {variation.numberedListVariationTitle[0] || `Option ${index + 1}`}
            </TabsItem>
          ))}
        </Tabs>
      </div>

      <div className={styles.tabContent}>
        {data.numberedListVariations.map((variation, index) => (
          <div
            key={variation.contentful_id}
            className={`${styles.tabPanel} ${
              activeTab === index.toString() ? styles.active : ""
            }`}
          >
            {variation.numberedListVariationSteps?.raw && (
              <div className={styles.stepsContent}>
                {renderEnhancedRichText(variation.numberedListVariationSteps.raw)}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}